import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

class UnitOfWorkTable extends Component {
  static propTypes = {
    feeTypes: PropTypes.object,
    staticData: PropTypes.object
  }

  renderRows = () => {
    const { feeTypes, staticData } = this.props

    const feeTypeRows = feeTypes.map(feeType => {
      const deliverableType =
        staticData.names.deliverableTypes[feeType.deliverableTypeId]
      const feeTypeName = staticData.names.feeTypes[feeType.feeTypeId]

      return (
        <tr key={feeType.id}>
          <td>{deliverableType}</td>
          <td>{feeTypeName}</td>
          <td>{feeType.value || '-'}</td>
          <td>{feeType.divisionCoefficient || '-'}</td>
          <td>{feeType.duration || '-'}</td>
        </tr>
      )
    })

    return <tbody>{feeTypeRows}</tbody>
  }

  render () {
    return (
      <table className='table-wrapper'>
        <thead>
          <tr>
            <th>Delivery type</th>
            <th>Fee type</th>
            <th>Value</th>
            <th>Value division</th>
            <th>Max. duration</th>
          </tr>
        </thead>
        {this.renderRows()}
      </table>
    )
  }
}

export default inject('staticData')(observer(UnitOfWorkTable))
